import commonActions from '@/store/data/common/actions'
import { errorHandler } from '@/utils/helpers'
import { webRequestClient } from '@/services'
import { isEmpty, get } from 'lodash'
import helpers from './helpers'
import { taxonomySegmentsRequestParamsConstructor } from '@/store/data/taxonomies/helpers'

const actions = {
    retrieveItems({ commit, rootGetters }) {
        commit('setIsLoading', true)
        const taxoId = rootGetters['data/customTaxonomies/getWamCustomTaxoId']({ type: 'data' })
        return webRequestClient
            .get(...taxonomySegmentsRequestParamsConstructor(taxoId))
            .then(data => {
                if (get(data, 'status') === 'KO') {
                    errorHandler('Error while retrieving 1st party data', commit)
                }
                if (!isEmpty(data.list)) {
                    commit('setRetrievedItems', {
                        items: helpers.parseData('data', data.list)
                    })
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    }
}

export default { ...commonActions, ...actions }
